import { jsx as _jsx } from "react/jsx-runtime";
import { MDXRemote } from 'next-mdx-remote';
export const MDXComponent = ({ compiledSource, components, scope, frontmatter, lazy, }) => {
    return (_jsx(MDXRemote, { compiledSource: compiledSource, components: components, scope: scope, lazy: lazy, frontmatter: frontmatter }));
};
